export default "__VITE_ASSET__DiWn63ua__"